import { useEffect, useState } from 'react';
import { Button } from '@grupoboticario/flora-react';
import UploadInput, { FilesCallback } from 'components/UploadInput';

import { downloadFile } from 'utils/downloadFile';
import { getPresignedUrl } from 'services/openClaimService';
import {
  CardDeclarationWrapper,
  CardDeclarationInfo,
  CardDeclarationUploadInput,
  CardDeclarationTitle,
  CardDeclarationRadio,
  CardDeclarationRadioText,
} from './styles';

interface ICardDeclarationUpload {
  setState: any;
  idDoc: string;
  title: string;
  files?: any;
  callbackFunc: (files: FilesCallback[]) => void;
  acceptedFiles?: string[];
  deleteFile: any;
  cpCode: number;
  franchiseCode: string;
}

const CardDeclarationUpload = ({
  setState,
  idDoc,
  title,
  files = [],
  callbackFunc,
  acceptedFiles,
  deleteFile,
  cpCode,
  franchiseCode,
}: ICardDeclarationUpload): JSX.Element => {
  const [dropFiles, setDropFiles] = useState([]);
  const [declaration, setDeclaration] = useState('');

  const preventEvent = (e: any) => {
    e.preventDefault();
  };

  const fileDrop = (e: any) => {
    e.preventDefault();
    const { files: dropedFiles } = e.dataTransfer;
    if (dropedFiles?.length) {
      setDropFiles(dropedFiles);
    }
  };

  const handleCallbackFunction = (callbackFiles: FilesCallback[]) => {
    callbackFunc(callbackFiles);
    setDropFiles([]);
  };

  const getDeclarationFile = async () => {
    const { data: presignedGetData } = await getPresignedUrl(
      'declaracao-de-outros-seguros.pdf',
      cpCode,
      franchiseCode,
    );
    setDeclaration(presignedGetData.response.URL);
  };

  useEffect(() => {
    if (!declaration) {
      getDeclarationFile();
    }
  }, [declaration]);
  return (
    <CardDeclarationWrapper
      onDragOver={preventEvent}
      onDragEnter={preventEvent}
      onDragLeave={preventEvent}
      onDrop={fileDrop}
    >
      <CardDeclarationInfo>
        <CardDeclarationTitle>{title}</CardDeclarationTitle>
        <CardDeclarationRadio>
          <div className="radioBlock">
            <CardDeclarationRadioText>
              É necessário que seja fornecida uma declaração sobre a existência
              ou inexistência de outros seguros. Para obtê-la, por gentileza,
              faça o download do documento abaixo, preencha todas as informações
              e, em seguida, realize o upload do arquivo no campo ao lado.
            </CardDeclarationRadioText>
          </div>

          <div className="radioBlock">
            <Button
              size="small"
              onClick={() =>
                downloadFile(declaration, `Declaracao de outros seguros`)
              }
            >
              Baixar documento
            </Button>
          </div>
        </CardDeclarationRadio>
      </CardDeclarationInfo>
      <CardDeclarationUploadInput>
        <UploadInput
          idDoc={idDoc}
          setState={setState}
          required={false}
          files={files}
          dropFiles={dropFiles}
          callbackFunc={handleCallbackFunction}
          deleteFile={deleteFile}
          acceptedFiles={acceptedFiles}
        />
      </CardDeclarationUploadInput>
    </CardDeclarationWrapper>
  );
};

export default CardDeclarationUpload;
